<template lang="pug">
  div
    a.u-flex.u-flex-ai-center(@click='modalOpen()', style='cursor: pointer;')
      i.icon-question-sign.u-mrs
      span(v-if='!is_icon_only') What’s TOM Premium?

    modal(
      :name='name'
      :width='is_smart_phone_device ? "90%" : "400px"'
      height='auto'
    )
      .c-panel.u-border-none
        .c-tom-premium--bgcolor.u-align-center.u-ptm.u-pbm
          img(
            :src="'/images/tom_premium_h_white.svg' | staticImageUrl",
            alt='TOM PREMIUM',
            width='260'
          )
          p(v-if="can_buy_with_annual_plan") ANNUAL PLAN UPGRADE
          p(v-else) 20,000+ MEMBERS STRONG
        .c-panel__body
          template(v-if='check_payment_methods')
            .c-message.c-message--warn.u-mt0.u-align-center
              | We’re unable to process the payment for your TOM Premium membership. Please update your payment information in order to access TOM Premium benefits.
              .u-mts
                a.c-btn.c-btn--alert(href='/orders/premium?payment_edit=true' target='orders_premium')
                  | Update Payment
          template(v-else)
            img.img-responsive.img-responsive--center(
              :src='benefitImageSrc | cloudImageUrl'
            )
            p.u-color-muted.u-fs-sm.u-mts.u-align-left(v-if="plan_type === 'first' && plan.type.first.term === 30")
              | Your <b>{{plan.type.first.term}}-day free trial</b> will <b>AUTO-RENEW at ${{plan.type.renewal.price.value}} (for {{plan.type.renewal.term}} days)</b>. In exchange, you’ll receive <b>{{renewalReceivePoints}} TOM Points</b> each time.
            p.u-color-muted.u-fs-sm.u-mts.u-align-left(v-else)
              | Your <b>{{plan.type[plan_type].term}}-day membership</b> will <b>AUTO-RENEW at ${{plan.type.renewal.price.value}}</b>. In exchange, you’ll receive <b>{{renewalReceivePoints}} in TOM Points</b> each time.
              span(v-if="can_buy_with_annual_plan")  When upgrading to the annual plan, you may also earn additional prorated TOM Points to cover the remainder of your pre-upgrade membership.
              span(v-else-if="plan_type === 'recontract'")  Auto-renew can be switched off starting in the second half of your 90-day membership.
          .u-flex.u-flex-dir-column.u-flex-ai-center.u-mts.u-mbs
            div(style="cursor: pointer; display:inline-block;" @click='close') close
</template>

<script>
import textUtil from '../../../util/text';
import {
  cloudImageUrl,
  staticImageUrl
} from '../../../util/url';

export default {
  name: 'whatsTomPremiumModal',
  filters: {
    cloudImageUrl,
    staticImageUrl
  },
  props: {
    name: String,
    is_smart_phone_device: Boolean,
    is_icon_only: Boolean,
    plan_type: String,
    plan: Object,
    check_payment_methods: Boolean,
    can_buy_with_annual_plan: Boolean
  },
  computed: {
    benefitImageSrc() {
      if (this.plan_type === 'first' && !this.can_buy_with_annual_plan) {
        return '/static/premium/common/400x177_en.png';
      }
      let prefix;
      if (this.plan_type === 'recontract') {
        prefix = 'premium-popup_recontract';
      } else {
        prefix = 'premium-popup';
      }
      if (this.can_buy_with_annual_plan) {
        prefix = 'premium-popup_annual';
      }
      const device = (this.is_smart_phone_device) ? 'sp' : 'pc';
      return `/static/premium/common/${prefix}_en-${device}.png`;
    },
    renewalReceivePoints() {
      const p = textUtil.currency(this.plan.type.renewal.point / 100);
      return p;
    }
  },
  methods: {
    modalOpen() {
      this.$modal.show(this.name);
    },
    close() {
      this.$modal.hide(this.name);
    }

  }
};
</script>
